import React from "react";
import { Route, Switch } from "react-router-dom";

import {ThemeProvider } from '@mui/material/styles';
import LRSTheme from "../../../themes/LRSTheme";

import Dashboard from "./Dashboard";
import StatementList from "./StatementList";

const LRSRouter = () => (
    <ThemeProvider theme={LRSTheme}>
        <Switch>
            <Route path="/lrs/statements" component={StatementList} />
            <Route path="/lrs/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default LRSRouter;